import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/store";
import { WorkspaceShell } from "@/features/workspace";
import { canAccessWorkspaceRoute, getDefaultWorkspaceRoute } from "@/lib/permissions";

export function ProtectedRoute() {
  const { session } = useAuth();
  if (!session) return <Navigate to="/" replace />;
  return (
    <WorkspaceShell>
      <Outlet />
    </WorkspaceShell>
  );
}

export function PublicOnlyRoute({ children }) {
  const { session } = useAuth();
  if (session) {
    return <Navigate to={getDefaultWorkspaceRoute(session)} replace />;
  }
  return children;
}

export function PermissionRoute({ children, permission, role }) {
  const { session } = useAuth();
  if (!canAccessWorkspaceRoute(session, { permission, role })) {
    return <Navigate to={getDefaultWorkspaceRoute(session)} replace />;
  }
  return children;
}
